// Debug block (top left, toggled with F3): frame rate, position, angles,
// draw statistics and network status.

import type { Vec3 } from '../../shared/math';
import { el } from './dom';

export interface DebugInfo {
  fps: number;
  origin: Vec3;
  angles: Vec3;
  velocityZ: number;
  noclip: boolean;
  draw: string;
  extra?: string;
}

export class Debug {
  readonly root = el('div', 'hud-debug');

  update(d: DebugInfo): void {
    this.root.textContent =
      `${Math.round(d.fps)} fps${d.noclip ? ' · NOCLIP' : ''}\n` +
      `pos ${d.origin.map((v) => v.toFixed(1)).join(' ')}\n` +
      `ang ${d.angles[0].toFixed(1)} ${d.angles[1].toFixed(1)} · vz ${Math.round(d.velocityZ)}` +
      (d.draw ? `\n${d.draw}` : '') +
      (d.extra ? `\n${d.extra}` : '');
  }
}
